<template>
  <div class="firstLoading">
    <p style="width: 100%;" v-for="item in bMerchant.noticeTemplateImages" :key="item">
      <img style="max-width: 100%;overflow-y: auto" :src="item">
    </p>
    <p style="margin:5pt 0pt; text-align:center">
      <span
        style="color:#333333;  font-size:7.5pt; font-weight:bold">本协议由汉唐融科提供</span>
    </p>
  </div>
</template>
<script>
import BusinessDict from "../../utils/businessDict";

export default {
  data(){
    return{
      loading:true,
      rate: "6.9",
      bMerchant: {
        merchantName: "",
        legalName: "",
        contactName: "",
        contactMobile: "",
        contactEmail: "",
        contactAddress: "",
        serviceRate: "*",
        noticeTemplateImages: [],
      },
    }
  },
  mounted() {
    const url = new URL(location.href);
    let b = url.searchParams.get('b');
    console.log(url, b);
    b = b || "lyfjkjyxgs";
    let bMerchant = BusinessDict.BMerchant[b];
    console.log(bMerchant);
    if (bMerchant) {
      this.bMerchant = bMerchant;
    }
    console.log(this.bMerchant);
  },
  methods:{
  }
}
</script>
<style lang="less" scoped>
.firstLoading{
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  text-align: left;
}
.loading-block{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 22px;
  font-size: 12px;
}
body { margin: 0;
  padding: 10px;
}
 .footer{
    display: flex;
    justify-content: space-around;
    padding-bottom:40px ;
  }
  .footer div{
    text-align: left;
  }
  .jia{
    position: relative;
  }
  .date{
    position: absolute;
    bottom: 0;
    left: 0;
  }
  p,div,span{
     font-family:宋体;
  }
</style>



// WEBPACK FOOTER //
// src/pages/agreement/aggreement_yz_merchant_template.vue